import { configureStore } from "@reduxjs/toolkit";
import clubReducer from "./clubSlice";
import { updateUserClubsList } from "./userSlice";
//import landingReducer from "./landingSlice";
import userReducer from "./userSlice";
//import landingReducer from "./landingSlice";
import searchBookReducer from "./searchBookSlice";
import { listenerMiddleware } from "../listenerMiddleware/listenMiddleware";
import { addUserClub} from "./userSlice";
import { addMember, setActiveClubId} from "./clubSlice";
//import { getBookById } from "../bookSource";
import { createClub } from "./clubSlice";
import suggestionsReducer from "./suggestionsSlice"
import { addBookSuggestion, vote } from "./suggestionsSlice";
import { addDoc } from "firebase/firestore";
import noteboardReducer, { addNote, removeNote } from "./noteboardSlice"

export const store = configureStore({
    reducer: {
        club: clubReducer,
        user: userReducer,
        searchBook: searchBookReducer,
        suggestions: suggestionsReducer,
        noteboard: noteboardReducer
    },
    middleware(getDefaultMiddleware) {
        return getDefaultMiddleware().concat(listenerMiddleware.middleware)
    } 
})

console.log("startat")

window.dispatch = store.dispatch;
window.addUserClub = addUserClub;
window.addMember = addMember
window.setActiveClubId = setActiveClubId
window.getSearchParams = () => store.getState().searchBook.searchParams;
//window.getBookById = getBookById
window.createClub = createClub;
window.addBookSuggestion = addBookSuggestion;
window.vote = vote;
window.removeNote = removeNote;
window.addNote = addNote;
window.addMember = addMember

